import { Space } from '../types/Space';
import { isUndefinedSpace } from './isUndefinedSpace';

export const fillUtilityProps = <T extends Space>(space: T): T => {
  const { visible, key } = space;
  const isEmpty = isUndefinedSpace(space);
  return {
    ...space,
    keyIf: visible ? key : undefined,
    isEmpty,
    exists: !isEmpty,
  };
};
